import { Divider, IconButton, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
  CcfAccordion,
  CcfAccordionDetails,
  CcfAccordionSummary,
  CcfBox,
  CcfDoubleArrowIcon,
  CcfPlusIcon,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { globalActions } from '../../../global.app.slice';
import CcfCustomerCardAddNotes from './ccf-customer-card-add-notes';
import styles from './ccf-customer-notes.module.scss';
import customerCardStyles from '../ccf-customer-card.styles';

const useStyles = makeStyles((theme) => ({
  customRootClass: {
    '&.MuiIconButton-root': {
      padding: '0px',
      stroke: '#007AB8',
      height: '22px',
    },
  },
}));

/* eslint-disable-next-line */
export interface CcfCustomerNotesProps {}

/**
 * CcfCustomerNotes - used to display Notes in contact card
 * @param props -? - CcfCustomerNotesProps
 * @example - <CcfCustomerNotes />
 */
export function CcfCustomerNotes(props: CcfCustomerNotesProps) {
  const theme = useTheme();
  const stylesAccordion = customerCardStyles(theme);
  const classes = useStyles();
  const [expanded, setExpanded] = useState('noteschannel');
  const [addNote, setAddNote] = useState(false);
  const { setIsEditContactCardNote } = globalActions;
  const dispatch = useDispatch();
  const Notes = [
    {
      message: 'Liam is an avid golfer. His favorite brand is callaway.',
      isEdit: false,
      edited: false,
    },
    {
      message: 'Liam travels to Scottsdale every year to go golfing',
      isEdit: false,
      edited: false,
    },
  ];
  const [contactNotes, setContactNotes] = useState(Notes);

  const dropdownOptions = {
    menuItems: [
      {
        items: [
          {
            label: 'Edit',
            closeOnSelection: true,
          },
          {
            label: 'Delete',
            closeOnSelection: true,
          },
        ],
      },
    ],
  };

  /**
   * handleChange Event - used to expand and collapse of channels accordion
   * @param panel- 'contacthistory'
   * @param event - changeevent
   * @param newExpanded - boolean
   * @example - handleChange(panel)
   */
  const handleChange =
    (panel: string) =>
    {
      setExpanded(expanded === 'noteschannel' ? '' : panel);
    };

  /**
   * handleAddNote function used to add new note block
   * @param e  - any
   * @example
   */
  const handleAddNote = (e: any) => {
    setAddNote(true);
    setAddNote((state) => {
      return state;
    });
    dispatch(setIsEditContactCardNote(true));
    e.stopPropagation();
  };

  /**
   * handleSaveNoteContactCard function used to save new note
   * @param e  - any
   * @example
   */
  const handleSaveNoteContactCard = (newNote: any, noteIndex: any) => {
    const contactNotesCopy = Object.assign([], contactNotes);
    if (!addNote) {
      contactNotesCopy.map((item: any, index: any) => {
        if (index === noteIndex) {
          item.message = newNote;
          item.edited = true;
        }
        item.isEdit = false;
      });
      setContactNotes(contactNotesCopy);
    } else {
      const tempNotesCopy = [
        { message: newNote, isEdit: false, edited: false },
        ...contactNotesCopy,
      ];
      setContactNotes(tempNotesCopy);
    }

    setContactNotes((state) => {
      return state;
    });
    setAddNote(false);
  };

  /**
   * handleEditNoteContactCard function used to save new note
   * @param e  - any
   * @example
   */
  const handleEditNoteContactCard = (noteIndex: any) => {
    const contactNotesCopy = Object.assign([], contactNotes);
    contactNotesCopy.map((note: any, index: any) => {
      if (index === noteIndex) {
        note.isEdit = true;
      }
    });
    setContactNotes(contactNotesCopy);
  };

  /**
   * Handle cancel note to cancel note
   * @param e -
   * @example -
   */
  const handleCancelNote = (
    labelText: string,
    e?: any,
    noteIndex?: any,
    oldnote?: string
  ) => {
    const contactNotesCopy = Object.assign([], contactNotes);
    if (!addNote) {
      contactNotesCopy.map((item: any, index: any) => {
        if (index === noteIndex) {
          item.isEdit = false;
          item.message = oldnote;
        }
      });
      setContactNotes(contactNotesCopy);
    }
    setAddNote(false);
    e && e.stopPropagation();
  };

  /**
   * Handle Delete note to delete note
   * @param e -
   * @example -
   */
  const handleDeleteNote = (noteIndex?: any) => {
    setContactNotes(
      contactNotes.filter((note: any, index: any) => index !== noteIndex)
    );
  };

  return (
    <CcfAccordion
      square
      expanded={expanded === 'noteschannel'}
      onChange={() => handleChange('noteschannel')}
      sx={stylesAccordion.accordionContainer}
    >
      <CcfAccordionSummary
        expandIcon={<CcfDoubleArrowIcon sx={stylesAccordion.expandedIcon} />}
        aria-controls="notes-channel-header"
        sx={
          expanded === 'noteschannel'
            ? stylesAccordion.accordionHeaderExpand
            : stylesAccordion.ccfAppSpaceAccordionHeader
        }
        id="agent_appSpace_notes"
      >
        <CcfBox className={styles.contactNoteInfo}>
          <CcfBox component="div" className={styles.titleRow}>
            <CcfTypography className={styles.title}>Notes </CcfTypography>
            <IconButton
              classes={{ root: styles.addIcon }}
              disableRipple
              onClick={(e) => handleAddNote(e)}
            >
              <CcfPlusIcon
                classes={{
                  root: styles.addIconColor,
                }}
              />
            </IconButton>
          </CcfBox>
        </CcfBox>
      </CcfAccordionSummary>
      <CcfAccordionDetails>
        {addNote && (
          <CcfCustomerCardAddNotes
            isFromWebChat={false}
            handleCancelNote={handleCancelNote}
            handleSaveNoteContactCard={handleSaveNoteContactCard}
            notesContentFromContactCard={{ message: '', isEdit: true }}
          />
        )}
        <section className={styles.noteContainer}>
          {contactNotes.map((note: any, index: any) => {
            return (
              <>
                <CcfCustomerCardAddNotes
                  isFromWebChat={false}
                  handleCancelNote={handleCancelNote}
                  handleDeleteNote={handleDeleteNote}
                  handleSaveNoteContactCard={handleSaveNoteContactCard}
                  notesContentFromContactCard={note}
                  noteId={index}
                  handleEditNoteContactCard={handleEditNoteContactCard}
                />
                <Divider
                  style={{
                    backgroundColor: '#B0CDDB',
                    opacity: index + 1 === contactNotes.length ? '0.5' : '0.8',
                  }}
                />
              </>
            );
          })}
        </section>
      </CcfAccordionDetails>
    </CcfAccordion>
  );
}

export default CcfCustomerNotes;
